/* Memoria: small text fixes for the options app (Globo Product Options) on the product page.
   - The empty first choice of a dropdown ("-- Please select --") reads "Maak een keuze" (EN: "Please choose").
   - Globo's English line "Selections will add € 10,00 to the price" becomes Dutch on the Dutch site.
   Globo renders (and re-renders) its fields after page load, so a MutationObserver keeps this up to date.
   - Desktop gallery (stacked: first photo full width, then two by two): when an odd number of photos
     follows the first one, the last visible photo also gets the full width, so there is never a lone
     half-width photo next to an empty area. Recomputed when a variant (askleur/kleur) is chosen. */
(function () {
  if (window.mmPdpTexts) return;
  window.mmPdpTexts = true;
  var EN = /^en/i.test(document.documentElement.lang || '');
  var PLACEHOLDER = /^\s*-*\s*(please\s+select|select\s+an?\s+option|choose\s+an?\s+option|selecteer|kies)\b[^]*$/i;
  var CHOOSE = EN ? 'Please choose' : 'Maak een keuze';

  function fixSelects(root) {
    root.querySelectorAll('.gpo-element select, .gpo-select select').forEach(function (sel) {
      Array.prototype.forEach.call(sel.options, function (o) {
        if (!o.value && (PLACEHOLDER.test(o.text) || !o.text.trim()) && o.text !== CHOOSE) o.text = CHOOSE;
      });
      var cur = sel.options[sel.selectedIndex];
      sel.classList.toggle('mm-placeholder', !cur || !cur.value);
      if (!sel.dataset.mmBound) {
        sel.dataset.mmBound = '1';
        sel.addEventListener('change', function () {
          var c = sel.options[sel.selectedIndex];
          sel.classList.toggle('mm-placeholder', !c || !c.value);
        });
      }
    });
  }
  function fixDropdowns(root) {
    root.querySelectorAll('.gpo-dropdown .dropdown-button__value').forEach(function (v) {
      if (PLACEHOLDER.test(v.textContent)) v.textContent = '';
    });
  }
  function fixTotals(root) {
    if (EN) return;
    root.querySelectorAll('.gpo-total-text').forEach(function (el) {
      var t = el.textContent;
      var m = t.match(/Selections?\s+will\s+add\s+(.+?)\s+to\s+the\s+price/i);
      if (m) {
        var money = el.querySelector('.money');
        var amount = money ? money.textContent : m[1];
        var txt = 'Uw keuzes voegen ' + amount + ' toe aan de prijs';
        if (el.textContent !== txt) el.textContent = txt;
      }
    });
  }
  /* Rustige standaardkeuzes: "Geen toevoeging (standaard)" en "As zichtbaar" staan aan zolang er nog niets gekozen is. */
  function setDefaults(root) {
    root.querySelectorAll('.gpo-element .gpo-ov-wrapper.vertical').forEach(function (w) {
      if (w.dataset.mmDefault) return;
      var radios = w.querySelectorAll('input[type=radio]');
      if (!radios.length) return;
      w.dataset.mmDefault = '1';
      if (Array.prototype.some.call(radios, function (r) { return r.checked; })) return;
      var pick = Array.prototype.find.call(radios, function (r) { return /standaard|^as zichtbaar$|^geen\b/i.test(r.value) && !r.disabled; });
      if (pick) { var l = w.querySelector('label[for="' + pick.id + '"]'); if (l) l.click(); else pick.click(); }
    });
  }

  /* Info-popups van Globo (ⓘ bij "Toevoeging" en "Zichtbaarheid As"): de inhoud uit de app heeft vaste
     stijlen en grote, ingezoomde foto's. We bouwen hem om tot een rustig venster: korte tekst en twee
     voorbeeldfoto's naast elkaar. Toevoeging toont de Memoria-voorbeelden met as (glitter / bladgoud). */
  var CDN = 'https://cdn.shopify.com/s/files/1/0926/4660/5177/files/';
  var POPS = {
    toevoeging: {
      test: /glitterpoeder/i,
      title: 'Toevoeging',
      text: 'Een subtiele afwerking in de steen, naast de as van uw dierbare. Zilveren sieraden krijgen zilverkleurige glitter, gouden sieraden goudkleurige. Alles wordt met de hand aangebracht, dus elk sieraad is uniek.',
      items: [
        { src: CDN + 'memoria-voorbeeld-glitter.jpg?v=1791091519&width=700', pos: '54% 55%', zoom: 1.55, label: 'Glitterpoeder', sub: 'Voorbeeld: as met glitterpoeder', alt: 'Voorbeeld: zilveren ring met antraciet as en glitterpoeder' },
        { src: CDN + 'memoria-voorbeeld-bladgoud.jpg?v=1791091520&width=700', pos: '52% 48%', zoom: 1.5, label: 'Bladgoud', sub: 'Voorbeeld: as met bladgoud', alt: 'Voorbeeld: gouden ring met antraciet as en bladgoud' }
      ]
    },
    zichtbaarheid: {
      test: /zichtbaarheid/i,
      title: 'Zichtbaarheid as',
      text: 'Bij as zichtbaar blijven kleine, lichte vlokjes as subtiel te zien in de steen. Bij as onzichtbaar wordt de as volledig verwerkt en oogt de steen egaal en rustig. Hieronder dezelfde ring, ter vergelijking.',
      items: [
        { src: CDN + 'memoria-as-zichtbaar.jpg?v=1791093388&width=700', pos: '50% 50%', zoom: 1, label: 'As zichtbaar', sub: 'Lichte vlokjes as in de steen', alt: 'Zilveren ring met zichtbare lichte askorrels in de antraciet steen' },
        { src: CDN + 'memoria-as-onzichtbaar.jpg?v=1791094212&width=700', pos: '50% 50%', zoom: 1, label: 'As onzichtbaar', sub: 'Egale, rustige steen', alt: 'Dezelfde zilveren ring met een egale antraciet steen, as niet zichtbaar' }
      ]
    }
  };
  function esc(t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function fixPopups() {
    var vv = window.visualViewport;
    document.querySelectorAll('.gpo-modal-dialog').forEach(function (dlg) {
      dlg.classList.add('mm-pop-dialog');
      /* op telefoons kan het layout-venster breder zijn dan het scherm: venster op het zichtbare deel zetten */
      if (vv && vv.width < window.innerWidth - 1) {
        dlg.style.cssText += ';left:' + vv.offsetLeft + 'px;top:' + vv.offsetTop + 'px;right:auto;bottom:auto;width:' + vv.width + 'px;height:' + vv.height + 'px';
      }
    });
    document.querySelectorAll('.gpo-modal-dialog .gpo-modal__content:not([data-mm-pop])').forEach(function (c) {
      c.setAttribute('data-mm-pop', '1');
      var txt = c.textContent || '';
      var cfg = null;
      if (!EN) for (var k in POPS) if (POPS[k].test.test(txt)) { cfg = POPS[k]; break; }
      if (cfg) {
        c.innerHTML = '<div class="mm-pop">' +
          '<h3 class="mm-pop__title">' + esc(cfg.title) + '</h3>' +
          '<p class="mm-pop__text">' + esc(cfg.text) + '</p>' +
          '<div class="mm-pop__grid">' + cfg.items.map(function (it) {
            return '<figure class="mm-pop__fig"><div class="mm-pop__img"><img src="' + it.src + '" alt="' + esc(it.alt) +
              '" loading="lazy" style="object-position:' + it.pos + ';transform-origin:' + it.pos + ';transform:scale(' + it.zoom + ')"></div>' +
              '<figcaption><span class="mm-pop__label">' + esc(it.label) + '</span><span class="mm-pop__sub">' + esc(it.sub) + '</span></figcaption></figure>';
          }).join('') + '</div></div>';
      } else {
        /* andere popups: alleen de vaste stijlen weg, zodat de nette opmaak uit de CSS geldt */
        c.classList.add('mm-pop--plain');
        c.querySelectorAll('[style]').forEach(function (e) { e.removeAttribute('style'); });
      }
    });
    /* ⓘ-titels ook met toetsenbord te openen */
    document.querySelectorAll('.product__info-container .gpo-modal__title:not([data-mm-key])').forEach(function (t) {
      t.setAttribute('data-mm-key', '1'); t.setAttribute('tabindex', '0'); t.setAttribute('role', 'button');
      t.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); lastTrigger = t; t.click(); } });
    });
    watchSheets();
  }
  /* Popup-gedrag (4-10): op telefoons (<750px) een bottom sheet die van onder inschuift, op desktop het
     gecentreerde venster. Sluiten via x, tik op de achtergrond, omlaag vegen of Escape. Pagina scrollt niet
     mee, focus blijft in het venster en de Shopify Inbox-chatknop ("Hulp nodig?") is zolang verborgen. */
  var MOB = window.matchMedia('(max-width: 749px)');
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)');
  var sheet = null; /* { dlg, modal, trigger, y } */
  var lastTrigger = null;
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])';
  function lockScroll() {
    var y = window.scrollY || window.pageYOffset || 0;
    var b = document.body.style;
    b.position = 'fixed'; b.top = -y + 'px'; b.left = '0'; b.right = '0'; b.width = '100%';
    document.documentElement.classList.add('mm-pop-open');
    return y;
  }
  function unlockScroll(y) {
    var b = document.body.style;
    b.position = ''; b.top = ''; b.left = ''; b.right = ''; b.width = '';
    document.documentElement.classList.remove('mm-pop-open');
    window.scrollTo(0, y || 0);
  }
  function onKey(e) {
    if (!sheet) return;
    if (e.key === 'Escape') { e.preventDefault(); closeSheet(); return; }
    if (e.key !== 'Tab') return;
    var f = Array.prototype.filter.call(sheet.modal.querySelectorAll(FOCUSABLE), function (el) { return el.offsetParent !== null; });
    if (!f.length) { e.preventDefault(); return; }
    var first = f[0], last = f[f.length - 1];
    if (!sheet.modal.contains(document.activeElement) || document.activeElement === sheet.modal) { e.preventDefault(); (e.shiftKey ? last : first).focus(); }
    else if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }
  function openSheet(dlg) {
    var modal = dlg.querySelector('.gpo-modal-dialog__modal');
    if (!modal) return;
    var close = dlg.querySelector('.gpo-modal__close-button');
    var title = dlg.querySelector('.mm-pop__title, .gpo-modal__content h1, .gpo-modal__content h2, .gpo-modal__content h3');
    modal.setAttribute('role', 'dialog'); modal.setAttribute('aria-modal', 'true'); modal.setAttribute('tabindex', '-1');
    if (title) { title.id = title.id || 'mm-pop-title'; modal.setAttribute('aria-labelledby', title.id); }
    if (close) {
      close.setAttribute('role', 'button'); close.setAttribute('tabindex', '0'); close.setAttribute('aria-label', EN ? 'Close' : 'Sluiten');
      close.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); closeSheet(); } });
      close.addEventListener('click', function (e) { if (dlg.hasAttribute('data-mm-closing')) return; e.preventDefault(); e.stopImmediatePropagation(); closeSheet(); }, true);
    }
    if (!modal.querySelector('.mm-pop__grip')) {
      var grip = document.createElement('div'); grip.className = 'mm-pop__grip'; grip.setAttribute('aria-hidden', 'true');
      modal.insertBefore(grip, modal.firstChild);
    }
    /* tik naast het venster = sluiten */
    dlg.addEventListener('click', function (e) { if (!modal.contains(e.target)) { e.preventDefault(); e.stopPropagation(); closeSheet(); } });
    sheet = { dlg: dlg, modal: modal, trigger: lastTrigger, y: lockScroll() };
    bindSwipe(sheet);
    document.addEventListener('keydown', onKey, true);
    requestAnimationFrame(function () { requestAnimationFrame(function () { dlg.classList.add('mm-pop-in'); }); });
    setTimeout(function () { try { modal.focus({ preventScroll: true }); } catch (err) { modal.focus(); } }, 30);
  }
  function finishClose(s) {
    var bd = document.querySelectorAll('.gpo-backdrop');
    var gclose = s.dlg.querySelector('.gpo-modal__close-button');
    /* Globo zelf laten opruimen (zijn eigen klik), anders zelf weghalen */
    if (gclose && document.body.contains(s.dlg)) {
      var ev = document.createEvent('MouseEvents'); ev.initEvent('click', true, true); ev.mmInternal = true;
      s.dlg.setAttribute('data-mm-closing', '1');
      gclose.dispatchEvent(ev);
    }
    setTimeout(function () {
      if (document.body.contains(s.dlg)) { s.dlg.remove(); bd.forEach(function (b) { b.remove(); }); }
    }, 60);
  }
  function closeSheet() {
    if (!sheet) return;
    var s = sheet; sheet = null;
    document.removeEventListener('keydown', onKey, true);
    s.dlg.classList.remove('mm-pop-in'); s.dlg.classList.add('mm-pop-out');
    s.modal.style.transform = '';
    var wait = RM.matches ? 0 : 280;
    setTimeout(function () {
      finishClose(s);
      unlockScroll(s.y);
      if (s.trigger && document.body.contains(s.trigger)) { try { s.trigger.focus({ preventScroll: true }); } catch (err) {} }
    }, wait);
  }
  function bindSwipe(s) {
    var startY = 0, dy = 0, drag = false, t0 = 0;
    var body = s.modal.querySelector('.gpo-modal__body') || s.modal;
    s.modal.addEventListener('touchstart', function (e) {
      if (!MOB.matches || e.touches.length !== 1) return;
      var onTop = e.target.closest('.mm-pop__grip, .gpo-modal__header') || body.scrollTop <= 0;
      if (!onTop) return;
      drag = true; startY = e.touches[0].clientY; dy = 0; t0 = Date.now();
    }, { passive: true });
    s.modal.addEventListener('touchmove', function (e) {
      if (!drag) return;
      dy = e.touches[0].clientY - startY;
      if (dy <= 0) { s.modal.style.transform = ''; return; }
      if (e.cancelable) e.preventDefault();
      s.modal.classList.add('mm-dragging');
      s.modal.style.transform = 'translateY(' + dy + 'px)';
    }, { passive: false });
    function end() {
      if (!drag) return;
      drag = false; s.modal.classList.remove('mm-dragging');
      var v = dy / Math.max(Date.now() - t0, 1);
      if (dy > 110 || (dy > 40 && v > 0.6)) closeSheet(); else s.modal.style.transform = '';
    }
    s.modal.addEventListener('touchend', end);
    s.modal.addEventListener('touchcancel', end);
  }
  function watchSheets() {
    var dlg = document.querySelector('.gpo-modal-dialog');
    if (dlg && !dlg.hasAttribute('data-mm-closing') && !dlg.dataset.mmSheet && dlg.querySelector('[data-mm-pop]')) {
      dlg.dataset.mmSheet = '1';
      if (sheet && sheet.dlg !== dlg) { var o = sheet; sheet = null; unlockScroll(o.y); }
      openSheet(dlg);
    } else if (sheet && !document.body.contains(sheet.dlg)) {
      /* Globo heeft het venster zelf gesloten */
      var s = sheet; sheet = null;
      document.removeEventListener('keydown', onKey, true);
      unlockScroll(s.y);
      if (s.trigger && document.body.contains(s.trigger)) { try { s.trigger.focus({ preventScroll: true }); } catch (err) {} }
    }
  }
  /* Lettertype-tegels bij Gravure: scherpere afbeelding voor de bredere tegel */
  function fixFontTiles(root) {
    root.querySelectorAll('.gpo-swatches.image-swatches .swatch-image').forEach(function (img) {
      if (img.dataset.mmSharp) return;
      img.dataset.mmSharp = '1';
      if (/[?&]width=\d+/.test(img.src)) img.src = img.src.replace(/([?&]width=)\d+/, '$1480');
    });
  }
  var DESK = window.matchMedia('(min-width: 990px)');
  function fixGallery() {
    document.querySelectorAll('.product--stacked .product__media-list').forEach(function (list) {
      var items = Array.prototype.filter.call(list.children, function (li) { return li.classList.contains('product__media-item'); });
      items.forEach(function (li) { li.classList.remove('mm-media-wide'); });
      if (!DESK.matches) return;
      var vis = items.filter(function (li) { return getComputedStyle(li).display !== 'none'; });
      if (vis.length > 1 && (vis.length - 1) % 2 === 1) vis[vis.length - 1].classList.add('mm-media-wide');
    });
  }
  var queued;
  function run() {
    clearTimeout(queued);
    queued = setTimeout(function () {
      var root = document.querySelector('.product__info-container') || document;
      fixSelects(root);
      fixTotals(root);
      fixDropdowns(root);
      setDefaults(root);
      fixFontTiles(root);
      fixPopups();
      fixGallery();
    }, 40);
  }
  function start() {
    run();
    var target = document.querySelector('.product__info-container') || document.body;
    if (window.MutationObserver) new MutationObserver(run).observe(target, { childList: true, subtree: true });
    var media = document.querySelector('.product--stacked .product__media-list');
    if (media && window.MutationObserver) new MutationObserver(run).observe(media, { childList: true, attributes: true, attributeFilter: ['class'], subtree: false });
    if (window.MutationObserver) new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) if (list[i].addedNodes.length || list[i].removedNodes.length) { fixPopups(); return; }
    }).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('click', function (e) {
      var tr = e.target.closest && e.target.closest('.gpo-modal__title, .gpo-modal');
      if (tr) lastTrigger = tr.closest('.gpo-modal__title') || tr;
      if (tr) [30, 200, 600].forEach(function (t) { setTimeout(fixPopups, t); });
    }, true);
    window.addEventListener('resize', run);
    window.addEventListener('load', run);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
